import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.from";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.set-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.parse-int";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/es.string.split";
import "core-js/modules/web.dom-collections.for-each";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint-disable react/no-array-index-key */
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { reduxForm, Field } from 'redux-form';
import { getFormErrors, getFormValues } from 'helpers/forms';
import { MIN_AGE, MAX_AGE, DEFAULT_AGE } from 'constants/video';
import { submitUserInformation } from 'containers/DeviceSetupModal/device-setup-modal.saga';
import { isEmpty } from 'helpers/verify';
import { InputField } from '../FormFields/InputField';
import { validators } from './validators';

var getFormDates = function getFormDates() {
  var now = new Date();
  var defaultBirthYear = now.getFullYear() - DEFAULT_AGE;
  var defaultBirthDate = new Date(defaultBirthYear, 0, 1);
  var maxBirthYear = now.getFullYear() - MIN_AGE;
  var inputYearsCount = MAX_AGE - (now.getFullYear() - maxBirthYear);
  return {
    defaultBirthDate: defaultBirthDate,
    inputYearsCount: inputYearsCount,
    maxBirthYear: maxBirthYear
  };
};

var formDates = getFormDates();
export var formConfig = {
  form: 'device-setup',
  validate: validators
};
var getErrors = getFormErrors(formConfig.form);
var getValues = getFormValues(formConfig.form);
export var mapStateToProps = function mapStateToProps(state) {
  var userProfile = state.entities.userProfile.data.default;
  var birthDate = userProfile.date_of_birth ? new Date(userProfile.date_of_birth.split('-')) : formDates.defaultBirthDate;
  var errors = getErrors(state);
  var errorMessages = !isEmpty(errors) && {
    birthDate: errors.birthDateMonth || errors.birthDateDay || errors.birthDateYear,
    gender: errors.gender,
    weight: errors.weight
  } || {};
  return _objectSpread({
    errorMessages: errorMessages,
    initialValues: {
      gender: userProfile.gender,
      birthDateMonth: (birthDate.getMonth() + 1).toString(),
      birthDateDay: birthDate.getDate().toString(),
      birthDateYear: birthDate.getFullYear().toString(),
      weight: userProfile.weight && userProfile.weight.lb
    }
  }, formDates, getValues(state));
};
export var DeviceSetupInformationUnwrapped =
/*#__PURE__*/
function (_React$Component) {
  _inherits(DeviceSetupInformationUnwrapped, _React$Component);

  function DeviceSetupInformationUnwrapped() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, DeviceSetupInformationUnwrapped);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(DeviceSetupInformationUnwrapped)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "handleSubmit", function (event) {
      var handleSubmit = _this.props.handleSubmit;
      handleSubmit(submitUserInformation)(event);
    });

    return _this;
  }

  _createClass(DeviceSetupInformationUnwrapped, [{
    key: "daysInMonth",
    value: function daysInMonth(month, year) {
      var mo = month || 0;
      var yr = year || 1970;
      return new Date(parseInt(yr, 10), parseInt(mo, 10) + 1, 0).getDate();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          birthDateMonth = _this$props.birthDateMonth,
          birthDateYear = _this$props.birthDateYear,
          errorMessages = _this$props.errorMessages,
          inputYearsCount = _this$props.inputYearsCount,
          localMaxBirthYear = _this$props.maxBirthYear,
          submitting = _this$props.submitting;
      var daysInMonth = this.daysInMonth(birthDateMonth - 1, birthDateYear);
      return React.createElement("div", null, React.createElement("div", {
        className: "modal__device-setup__top"
      }, React.createElement("h3", {
        className: "mv"
      }, React.createElement(FormattedMessage, {
        id: "device.info.header",
        defaultMessage: "Enter your details"
      })), React.createElement("div", {
        className: "p-"
      }, React.createElement(FormattedMessage, {
        id: "device.info.copy",
        defaultMessage: "We use your personal information to determine your heart rate zones and calorie burn. This makes your workout as effective as possible.",
        tagName: "p"
      }))), React.createElement("div", {
        className: "modal__device-setup__content"
      }, React.createElement("form", {
        onSubmit: this.handleSubmit,
        autoComplete: "on",
        className: "modal__device-information__form"
      }, React.createElement("div", null, React.createElement("label", {
        htmlFor: "gender",
        className: "modal__device-information__label mb-"
      }, React.createElement(FormattedMessage, {
        id: "gender",
        defaultMessage: "Gender"
      })), React.createElement(Field, {
        name: "gender",
        component: InputField,
        inputClassNames: "modal__device-information__select",
        inputTag: "select",
        suppressErrorMessage: true
      }, React.createElement("option", {
        value: ""
      }, "Select"), React.createElement("option", {
        value: "Female"
      }, "Female"), React.createElement("option", {
        value: "Male"
      }, "Male"))), errorMessages.gender && React.createElement("div", {
        id: "error-gender",
        className: "error__text text--sm mt-"
      }, React.createElement(FormattedMessage, errorMessages.gender)), React.createElement("fieldset", {
        className: "mt+"
      }, React.createElement("label", {
        htmlFor: "birthday",
        className: "modal__device-information__label mb-"
      }, React.createElement(FormattedMessage, {
        id: "device-setup.dob",
        defaultMessage: "Date of birth"
      })), React.createElement(Field, {
        name: "birthDateMonth",
        component: InputField,
        inputTag: "select",
        wrapperTag: "span",
        inputClassNames: "modal__device-information__select mr-",
        suppressErrorMessage: true
      }, ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'].map(function (val, idx) {
        return React.createElement("option", {
          key: "month".concat(idx),
          value: idx + 1
        }, val);
      })), React.createElement(Field, {
        name: "birthDateDay",
        component: InputField,
        inputTag: "select",
        wrapperTag: "span",
        inputClassNames: "modal__device-information__select mr-",
        suppressErrorMessage: true
      }, _toConsumableArray(Array(daysInMonth)).map(function (val, idx) {
        return React.createElement("option", {
          key: "day".concat(idx),
          value: idx + 1
        }, idx + 1);
      })), React.createElement(Field, {
        name: "birthDateYear",
        component: InputField,
        inputTag: "select",
        wrapperTag: "span",
        inputClassNames: "modal__device-information__select mr-",
        suppressErrorMessage: true
      }, _toConsumableArray(Array(inputYearsCount)).map(function (val, idx) {
        return React.createElement("option", {
          key: "year".concat(idx),
          value: localMaxBirthYear - idx
        }, localMaxBirthYear - idx);
      }))), errorMessages.birthDate && React.createElement("div", {
        id: "error-birth-date",
        className: "error__text text--sm mt-"
      }, React.createElement(FormattedMessage, errorMessages.birthDate)), React.createElement("div", {
        className: "modal__device-setup__weight-container mt+ mb-"
      }, React.createElement(Field, {
        suppressErrorMessage: true,
        component: InputField,
        name: "weight",
        inputAttributes: {
          autoComplete: 'weight',
          maxLength: '3'
        },
        wrapperAttributes: {
          className: 'inline-block mr-'
        },
        inputClassNames: "modal__device-setup__weight inline-block",
        label: React.createElement("span", {
          className: "modal__device-information__label mb-"
        }, React.createElement(FormattedMessage, {
          id: "device-setup.weight",
          defaultMessage: "Weight"
        }))
      }), React.createElement("span", {
        className: "modal__device-setup__weight-unit inline-block"
      }, "lbs")), errorMessages.weight && React.createElement("div", {
        id: "error-weight",
        className: "error__text text--sm mt-"
      }, React.createElement(FormattedMessage, errorMessages.weight)), React.createElement("div", {
        className: "text--center"
      }, React.createElement("button", {
        disabled: submitting,
        type: "submit",
        className: "bt bt--primary bt--width-md grid__item mt+"
      }, React.createElement(FormattedMessage, {
        id: "modal.next",
        defaultMessage: "Next"
      }))))));
    }
  }]);

  return DeviceSetupInformationUnwrapped;
}(React.Component);
DeviceSetupInformationUnwrapped.propTypes = {
  birthDateMonth: PropTypes.string,
  birthDateYear: PropTypes.string,
  errorMessages: PropTypes.object.isRequired,
  inputYearsCount: PropTypes.number.isRequired,
  handleSubmit: PropTypes.func,
  maxBirthYear: PropTypes.number,
  submitting: PropTypes.bool
};
export var DeviceSetupInformation = connect(mapStateToProps)(reduxForm(formConfig)(DeviceSetupInformationUnwrapped));